export const saveFile = (fileName: string, file: Blob) => {
    const blobURL = window.URL.createObjectURL(file);
    const a = document.createElement("a");
    a.href = blobURL;
    a.download = fileName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobURL);
}